// extracted by mini-css-extract-plugin
export default {"paragrafo":"ModalContato_paragrafo__hy84o"};